import { useBrand } from '@contexts/useBrand'
import { useState } from 'react'
import { upperCaseFirst } from 'upper-case-first'

type Props = {
  vehicle: string
  dealer: Object
  vrn: string
}

const UsedCarCard = ({ vehicle, dealer, vrn }: Props) => {
  const brand = useBrand()
  const [showAddress, setShowAddress] = useState(false)

  const handleClick = () => {
    setShowAddress(!showAddress)
  }

  return (
    <div
      className={
        'grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-8 md:mb-4'
      }
      data-gt-componentname="used-car-card"
    >
      <div className="border px-3 py-4 border-base-hover md:col-span-2 lg:col-span-1">
        <h3 className="text-xl">
          {vehicle || `${upperCaseFirst(brand)} used vehicle`}
        </h3>
        <h5 className="text-lg">{vrn}</h5>
        {dealer && (
          <address className="not-italic text-md mt-3">
            <button
              type="button"
              onClick={handleClick}
              className="cursor-pointer hover:underline inline-block"
              data-gt-name="componentevent"
              data-gt-action="click-address"
              data-gt-label={showAddress ? 'open-address' : 'close-address'}
            >
              {dealer.name}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className={`w-4 h-4 inline-block ml-2 ${
                  showAddress ? 'rotate-180' : ''
                }`}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
            </button>
            <div className={`${showAddress ? '' : 'hidden'} mt-2`}>
              <p>{dealer.defaultAddress.addressLine1}</p>
              <p>{dealer.defaultAddress.addressLine2}</p>
              <p>{dealer.defaultAddress.city}</p>
              <p>{dealer.defaultAddress.region}</p>
              <p>{dealer.defaultAddress.zip}</p>
            </div>
          </address>
        )}
      </div>
    </div>
  )
}

export default UsedCarCard
